import { getApiBaseUrl, getApiClient } from "./serviceconfig";
var apiBaseUrl = getApiBaseUrl();

export async function getInvoicenumber(cookies, plant_id, invoice_date) {
    let url = `${apiBaseUrl}/sales_invoices/invoice_number/?plant_id=${plant_id}&invoice_date=${invoice_date}`;
    return getApiClient(cookies).get(url)
        .then(response => response.data);
} 

export async function createSalesInvoice(cookies, inputs) {
    const isJson = Boolean(inputs.save_only);
    try {
        const response = await getApiClient(cookies).post(
            `${apiBaseUrl}/sales_invoices/`,
            inputs,
            { responseType: isJson ? 'json' : 'blob' },
        );
        return response.data;
    } catch (error) {
        const responseData = error?.response?.data;
        if (responseData instanceof Blob) {
            const text = await responseData.text();
            try {
                error.response.data = JSON.parse(text);
            } catch (parseError) {
                error.response.data = {
                    message: text || 'Save request failed.',
                    code: error?.response?.status,
                };
            }
        }
        throw error;
    }
}

export async function printSalesInvoice(cookies, invoiceId) {
    return getApiClient(cookies).get(`${apiBaseUrl}/sales_invoices/${invoiceId}/print_invoice/`, {
        responseType: 'blob',
    })
    .then(response => response.data)
    }

export async function getAllInvoices(cookies,inputs) {
    let url= `${apiBaseUrl}/sales_invoices/?plant_id=${inputs.plant_id}&customer_ids=${inputs.customer_ids}&from_date=${inputs.from_date}&upto_date=${inputs.upto_date}`;
        return getApiClient(cookies).get(url)
        .then(response => response.data);
    }

export async function getInvoiceDetails(cookies, invoiceId) {
    return getApiClient(cookies).get(`${apiBaseUrl}/sales_invoices/${invoiceId}/`)
                .then(response => response.data)
    }

export async function updateSalesInvoice(cookies, inputs,  invoiceId) {
    const isJson = Boolean(inputs.update_only);
    try {
        const response = await getApiClient(cookies).put(
            `${apiBaseUrl}/sales_invoices/${invoiceId}/`,
            inputs,
            { responseType: isJson ? 'json' : 'blob' },
        );
        return response.data;
    } catch (error) {
        const responseData = error?.response?.data;
        if (responseData instanceof Blob) {
            const text = await responseData.text();
            try {
                error.response.data = JSON.parse(text);
            } catch (parseError) {
                error.response.data = {
                    message: text || 'Update request failed.',
                    code: error?.response?.status,
                };
            }
        }
        throw error;
    }
}

export function deleteSalesInvoice(cookies, invoiceId) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/sales_invoices/${invoiceId}/`)
    }

export function cancelSalesInvoice(cookies, invoiceId, payload = {}) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/sales_invoices/${invoiceId}/`, payload)
        .then(response => response.data);
}